<template>
    <div class="commentPanel">
        <Loader :loading="loading"></Loader>
        <div class="headerPanel">
            <p>
                {{ $t("commentPanel.title") }}
                <span class="commentCount" :class="[inPanel ? 'pointer' : '']" @click="openCommentsModal"> {{ commentsLength }} </span>
                <span v-if="inPanel && commentsLength > 0" @click="togglePanel" class="openPanel fright pointer">v</span>
            </p>
        </div>
        <div class="panelBody">
            <div class="comments" :class="[inPanel ? '' : 'modalComment']" v-show="minimisePanel">
                <CommentBox v-for="comment in personalNotes" :key="comment.id" :comment="comment"></CommentBox>
                <CommentBox v-for="comment in comments" :key="comment.id" :comment="comment"></CommentBox>
            </div>
            <a v-if="inPanel && commentsLength > 0" v-show="minimisePanel" @click="openCommentsModal" class="allComments">{{
                $t("commentPanel.allComments")
            }}</a>
            <textarea class="newComment" v-model="newComment" :placeholder="$t('commentPanel.newCommentPh')"></textarea>
            <div class="commentFooter fright" v-if="inPanel">
                <button class="btn" @click="saveComment(true);">{{ $t("commentPanel.addPersonalNote") }}</button>
                <button class="btn" @click="saveComment(false);">{{ $t("commentPanel.addComment") }}</button>
            </div>
            <div class="commentFooter fright" v-else>
                <ClientColorButton :disabled="!canSave" @click="saveComment(true);">{{ $t("commentPanel.addPersonalNote") }}</ClientColorButton>
                <ClientColorButton :disabled="!canSave" @click="saveComment(false);">{{ $t("commentPanel.addComment") }}</ClientColorButton>
            </div>
        </div>
    </div>
</template>

<script>
import CommentBox from "./CommentBox";
import { mapGetters, mapActions } from "vuex";
import TryLoadMixin from "@/mixins/TryLoadMixin";
import Loader from "@/components/loader/loader";
import ClientColorButton from "@/components/ui/ClientColorButton";
import { bus } from "@/main";

export default {
    components: { CommentBox, Loader, ClientColorButton },
    props: ["inPanel", "appId", "commentData"],
    name: "CommentPanel",
    mixins: [TryLoadMixin],
    watch: {
        commentData() {
            this.loadComments();
        },
        commentsLength: {
            immediate: true,
            handler() {
                if (this.commentDatas) {
                    if (this.commentsLength > 0) {
                        bus.$emit("HAVE_COMMENTS");
                    } else {
                        bus.$emit("HAVE_NO_COMMENTS");
                    }
                }
            }
        }
    },
    data() {
        return {
            newComment: "",
            minimisePanel: true,
            countComments: 0,
            openStatus: null,
            closeStatus: null
        };
    },
    computed: {
        ...mapGetters("comment", {
            comments: "comments",
            personalNotes: "personalNotes",
            commentsLength: "commentsLength",
            commentDatas: "data",
            status: "status"
        }),
        ...mapGetters("currentUser", ["currentUser"]),
        populateData() {
            const limit = this.inPanel === true ? "limit=10&" : "";
            return { appId: this.appId, limit: limit, params: this.paramsGetter() };
        },
        canSave() {
            return Boolean(this.newComment);
        }
    },
    async created() {
        await this.fetchStatus();
        this.loadComments();
    },
    methods: {
        ...mapActions("comment", {
            populate: "populate",
            fetchStatus: "fetchStatus",
            saveNewComment: "saveNewComment"
        }),

        ...mapActions("events/comments", {
            dispatcherAddComment: "dispatcherAddComment"
        }),
        /* Function qui ajoute les paramètre additionelle à la requête comme l'id du plano ou du panier */
        paramsGetter() {
            let first = true;
            let params = "";
            for (let item in this.commentData) {
                params += (first ? "" : "&") + item + "=" + (this.commentData[item].id ? this.commentData[item].id : this.commentData[item]);
                if (first) {
                    first = false;
                }
            }
            return params;
        },
        async loadComments() {
            await this.tryLoad(() => this.populate(this.populateData));
        },
        openCommentsModal() {
            if (this.inPanel === true) {
                this.$emit("openModal", true);
            }
        },
        togglePanel() {
            this.minimisePanel = !this.minimisePanel;
        },
        async saveComment(isPersonal) {
            if (!this.canSave) return false;
            let comment = {
                isPersonal,
                printInPdf: true,
                isActive: true,
                content: this.newComment,
                commentStatus: { id: 1 },
                parent: null
            };
            Object.assign(comment, this.commentData);
            await this.tryLoad(() => this.saveNewComment({ appId: this.appId, comment }));
            const { id: user } = this.currentUser.user;
            const UUID = this.commentData.componentIdExternal;
            const type = comment.isPersonal === true ? "PRIVATE" : "PUBLIC";
            this.dispatcherAddComment({ user, type, UUID });
            this.dialogSuccess(this.$t("commentPanel.newCommentMessage"));
            if (this.minimisePanel === false) {
                this.minimisePanel = true;
            }
            this.newComment = "";
        }
    }
};
</script>

<style lang="scss">
.commentPanel {
    background-color: #ffffff;

    .comments {
        overflow-y: auto;
        max-height: 220px;
    }

    .comments.modalComment {
        padding: 20px;
        height: 450px;
        max-height: 1000px;
    }

    .headerPanel {
        background-color: #777777;
        color: #ffffff;
        text-transform: uppercase;
        font-size: 20px;
        padding: 8px 10px;

        p {
            margin: 0;
        }

        .commentCount {
            display: inline-block;
            background-color: #ffffff;
            text-align: center;
            height: 20px;
            width: 20px;
            border-radius: 50%;
            vertical-align: middle;
            color: #000000;
            margin-left: 5px;
            font-weight: bold;
            line-height: 20px;
        }
    }

    .panelBody {
        padding: 0 5px 5px 5px;
    }

    .allComments {
        text-align: right;
        margin-top: 15px;
        display: block;
        text-decoration: underline;
    }

    .commentButton {
        display: block;
        text-align: right;
        padding-right: 5px;

        button {
            background-color: #159191;
            border: none;
            outline: none;
            margin-top: 5px;
            color: #fff;
            padding: 2px 5px;
            border-radius: 50px;
            font-size: 10px;
        }
    }

    .newComment {
        margin-top: 8px;
        display: block;
        width: 100%;
        padding: 6px 6px 0 6px;
        background-color: transparent;
        color: #555555;
        border: none;
    }

    .commentFooter {
        width: 100%;
        border-top: 2px #000 solid;

        & > * {
            float: right;
            margin-left: 5px;
            margin-top: 5px;
            font-size: 13px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// CommentPanel.vue?6dad02a2